module.exports = __webpack_public_path__ + "img/access-denied.d001d8a3.svg";